import {useGoogleOneTapLogin} from "@react-oauth/google";
import {GoogleAuthOneTapLogin} from "../../API/ApiEndPoints/GoogleAuthApi";
import {toast} from "react-toastify";
import {useSession} from "../../redux/Reducers/AuthReducer";
import {BsEnvelopeAtFill, BsFillTelephoneFill} from "react-icons/bs";
import HomeHeader from "./components/Header/HomeHeader";
import Footer from "./components/Footer/Footer";
import Sidebar from "../../components/sidebar/Sidebar";


export default function LandingLayout(props) {
    const {session,authActions} = useSession();

    // useGoogleOneTapLogin({
    //     onSuccess: credentialResponse => {
    //         GoogleAuthOneTapLogin(credentialResponse?.credential).then((res) => {
    //             toast("Login Success", {
    //                 type: "success"
    //             });
    //             authActions.setSession(res?.data);
    //
    //
    //         }).catch((err) => {
    //             toast(err?.response?.data?.error || err?.message || "Something went wrong", {
    //                 type: "error"
    //             })
    //         })
    //     },
    //     onError: () => {
    //         toast("Something went wrong", {
    //             type: "error"
    //         })
    //     },
    //
    //     auto_select: false,
    //
    // });


    return (
        <div className={"no-scrollbar flex flex-col   min-h-[100vh]"}>
            {/*<Header/>*/}
            <HomeHeader/>
            {
                authActions.isUserAuthenticated() && <Sidebar/>
            }
            <div className={"flex-1 "}>
                {props.children}

            </div>

            <Footer/>


        </div>

    )
}
